<template>
  <div class="flex flex-col -mt-2">
    <div class="inline-block relative w-full">
      <select
        v-model="selectedFontFamily"
        class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2"
      >
        <option
          v-for="font in $store.state.fontsCollection"
          :key="font"
          :style="{ fontFamily: font }"
          :value="font"
        >
          {{ font }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
    <div class="inline-block relative w-full">
      <select
        v-model="selectedFontStyle"
        class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2"
      >
        <option
          v-for="style in $store.state.fontStyles"
          :key="style"
          :value="style"
        >
          {{ style }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
    <FontSliders
      v-model:font-size="selectedFontSize"
      v-model:shadow-intensity="selectedShadowIntensity"
    />
    <div class="flex flex-col items-center p-2 bg-gray-100 rounded shadow mt-4">
      <label class="mb-1 text-xs font-semibold">Text Color</label>
      <input
        v-model="selectedBodyFontColor"
        type="color"
        style="width: 40px; height: 40px; border: none; background: none;"
      >
      <span class="align-middle mt-1 text-xs">{{ selectedBodyFontColor }}</span>
    </div>
    <ResetButton
      v-if="$store.state.textChangeCounter > 0"
      resetwhat="text"
    />
  </div>
</template>
<script>
import ResetButton from '@/components/ResetButton.vue'
import FontSliders from './FontSliders.vue'

export default {
  name: 'BodyFontPicker',
  components: {
    ResetButton,
    FontSliders
  },
  props: {},
  data() {
    return {
      // swatches removed, not needed
    }
  },
  computed: {
    selectedFontFamily: {
      set(value) {
        this.$store.commit('setSelectedTextFontValues', { fontFamily: value })
      },
      get() {
        return this.$store.state.selectedTextFontValues.fontFamily
      }
    },
    selectedFontSize: {
      set(value) {
        this.$store.commit('setSelectedTextFontValues', { fontSize: value })
      },
      get() {
        return this.$store.state.selectedTextFontValues.fontSize
      }
    },
    selectedFontStyle: {
      set(value) {
        this.$store.commit('setSelectedTextFontValues', { fontStyle: value })
      },
      get() {
        return this.$store.state.selectedTextFontValues.fontStyle
      }
    },
    selectedBodyFontColor: {
      set(value) {
        this.$store.commit('setSelectedTextFontValues', { fontColor: value })
      },
      get() {
        return this.$store.state.selectedTextFontValues.fontColor
      }
    },
    selectedShadowIntensity: {
      set(value) {
        this.$store.commit('setSelectedTextFontValues', {
          shadowIntensity: value
        })
      },
      get() {
        return this.$store.state.selectedTextFontValues.shadowIntensity
      }
    }
  },
  methods: {}
}
</script>
